/**
 * Layout for everything under `/tickets/$key/*`.
 *
 * Renders just an <Outlet/> — the child routes (`index` for the
 * default ticket detail, `chat` for the dedicated full-viewport chat)
 * handle their own data fetching and not-found / loading states.
 *
 * Keeping the layout intentionally bare so each child can decide its
 * own chrome (the chat page wants a custom header; the detail view
 * uses the global app header).
 */
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/tickets/$key")({
  component: TicketLayout,
});

function TicketLayout() {
  return <Outlet />;
}
